import React, { memo, useMemo } from "react";

const RepliedPostMessageMC = memo(({ message }) => {
  const messageText = useMemo(() => message.messageText || '', [message.messageText]);
  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      <div className="tw-flex tw-items-center tw-gap-1">
        <i className="mi-external-link-outline tw-text-gray-400 tw-text-lg leading-none" />
        <span className="tw-text-gray-500 tw-text-xs tw-font-medium">
          Publicación
        </span>
      </div>
      <div className="tw-whitespace-pre-line tw-text-xs tw-text-gray-600 tw-truncate" dangerouslySetInnerHTML={{ __html: messageText }} />
    </div>
  );
});

RepliedPostMessageMC.displayName = 'RepliedPostMessageMC';

export default RepliedPostMessageMC;
